import Vue from './common/vue-common';
import Search from './components/search/Search';
import {windowSizeCb} from "../common/common";

cr$.ready(function () {

    const buildVueObject = (element) => ({
        el: element,
        name: 'SearchDesktop',
        components: {
            'search': Search
        },

        mounted(){
            this.bodyEl = document.querySelector('body');
        },

        data() {
            return {
                searchQuery: '',
                searchFocus: false,
                mouseIsOver: false,
                debugMode: false
            };
        },

        watch: {
            searchQuery(newVal) {
                if (newVal && newVal.length > 0) {
                    this.bodyEl.classList.add('only-search-visible');
                } else {
                    this.bodyEl.classList.remove('only-search-visible');
                }
            }
        },

        methods: {
            clearSearch() {
                this.searchQuery = "";
            }
        }
    });

    windowSizeCb(() => {
        const desktopSearch = document.getElementById('header-search-desktop');
        if (desktopSearch) {
            requestIdleCallback(() => {
                new Vue(buildVueObject(desktopSearch));
            });
        }
    }, () => {
        const mobileSearch = document.getElementById('header-search-mobile');
        if (mobileSearch){
            requestIdleCallback(() => {
                new Vue(buildVueObject(mobileSearch));
            });
        }
    });
});
